export default "__VITE_ASSET__CGfu5SjO__"